/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseTemplateRequest } from '../../models/api-response-template-request';
import { TemplateRequest } from '../../models/template-request';

export interface UpdateTemplateRequest$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
      body?: {
'media'?: Blob;
'templateRequest': TemplateRequest;
}
}

export function updateTemplateRequest(http: HttpClient, rootUrl: string, params: UpdateTemplateRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseTemplateRequest>> {
  const rb = new RequestBuilder(rootUrl, updateTemplateRequest.PATH, 'put');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseTemplateRequest>;
    })
  );
}

updateTemplateRequest.PATH = '/v1/api/ui/template-request/media/{reference}';
